module.exports = __webpack_public_path__ + "static/media/team-illustration-2.5ae3fe7a.svg";